import { render } from "./ItemBottom.vue?vue&type=template&id=0031c66f"
import script from "./ItemBottom.vue?vue&type=script&lang=js"
export * from "./ItemBottom.vue?vue&type=script&lang=js"

import exportComponent from "/home/ali/PhpstormProjects/insta-catalog-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__